import {UserTypeEnum} from "../../enums/user-type.enum";
import {EnterpriseDto} from "./enterprise-dto";
import {SoleTraderDto} from "./sole-trader-dto";
import {UserStatus} from "../../enums/user-status.enum";
import {SubscriptionDto} from "./subscription-dto";
import { ReviewDto } from "./review-dto";

export class UserDto {
  id: number
  lastname: string
  firstname: string
  birthdate: string
  type: UserTypeEnum
  phone: string
  email: string
  address: string
  city: string
  country: string
  postalCode: string
  region: string
  latitude: string
  longitude: string
  status: UserStatus
  proofSent: boolean
  profileImageUrl: string
  registerDate: Date
  newsletter: boolean
  mangopayTermsAndConditions: boolean
  enterprise: EnterpriseDto
  soleTrader: SoleTraderDto
  loyalty: number
  affiliationCode: string
  earned: number
  cashpot: number
  subscription: SubscriptionDto
  reviews: ReviewDto[]
}
